
import { ReactNode } from 'react';
import { MainLayout } from './MainSidebar';
import { LanguageProvider } from '@/contexts/LanguageContext';

interface LayoutProps {
  children: ReactNode;
  sidebarDefaultOpen?: boolean;
}

export const Layout = ({ children, sidebarDefaultOpen }: LayoutProps) => {
  return (
    <div className="min-h-screen w-full bg-background overflow-x-hidden relative">
      <LanguageProvider>
        <MainLayout sidebarDefaultOpen={sidebarDefaultOpen}>
          {children}
        </MainLayout>
      </LanguageProvider>
    </div>
  );
};
